import React from "react"
import { TrendingUp, Users, Zap } from "lucide-react"
import { useLang } from "./i18n/LangContext"

const ICONS = [Users, TrendingUp, Zap]
const VALUES = ["500+", "$2M+", "15 min"]

export function StatsSection() {
  const { t } = useLang()
  const labels = [t.stats.founders, t.stats.revenue, t.stats.setup]

  return (
    <section className="bg-white dark:bg-gray-950 border-y border-gray-100 dark:border-gray-800 py-14">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {ICONS.map((Icon, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <Icon className="h-5 w-5 text-brand-500 dark:text-brand-400 mb-1" />
              <span className="text-3xl font-bold text-gray-900 dark:text-white">{VALUES[i]}</span>
              <span className="text-sm text-gray-500 dark:text-gray-400">{labels[i]}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
